import React from "react";
import ReactDOM from "react-dom/client";
import { enforceTrdrPokemonCanonicalBrowserHost } from "./platform/shell/trdrPokemonCanonicalHostRedirect";
// import "./styles.css";

const canonicalHostRedirected = enforceTrdrPokemonCanonicalBrowserHost();

if (!canonicalHostRedirected) {
  import("./App").then(({ default: App }) => {
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<App />);
  });
}
